module.exports = __webpack_public_path__ + "5f6ebfb9bb22ff178d21f9489975776a.png";